// π ----
// :: MODULES BOOTSTRAP ---------------------------::
// ____

/* :: Imports
---------------------------------- */
import Vue from 'vue';
import cookieconsent from 'vue-cookieconsent-component';
import VueClipboard from 'vue-clipboard2';
import LazyLoadDirective from './utilities/directives/LazyLoadDirective';

import animation from './partials/components/animate.vue';
import blob from './partials/components/blob.vue';
import classSlider from './partials/modules/ClassSlider.vue';
import fadeIn from './partials/components/animations/FadeIn.vue';
import fadeInUp from './partials/components/animations/FadeInUp.vue';
import headerSticky from './partials/modules/HeaderSticky.vue';
import headerRiverwatch from './partials/modules/header-riverwatch.vue';
import heroHome from './partials/modules/HeroHome.vue';
import heroImax from './partials/modules/HeroImax.vue';
import hero from './partials/modules/Hero.vue';
import hiddenNav from './partials/modules/HiddenNavigation.vue';
import imageItem from './partials/components/ImageItem.vue';
import imageSlider from './partials/modules/ImageSlider.vue';
import imaxHome from './partials/modules/ImaxHome.vue';
import linesUp from './partials/components/animations/LinesUp.vue';
import liveBlinker from './partials/components/LiveBlinker.vue';
import livestream from './partials/modules/Livestream.vue';
import location from './partials/modules/Location.vue';
import magnetic from './partials/components/Magnetic.vue';
import maps from './partials/modules/Maps.vue';
import mediaGrid from './partials/modules/MediaGrid.vue';
import modal from './partials/modules/modal.vue';
import newsletter from './partials/modules/newsletter.vue';
import parallaxBg from './partials/components/ParallaxBg.vue';
import plyr from './partials/blocks/video.vue';
import reviewSlider from './partials/modules/ReviewSlider.vue';
import riverwatch from './templates/riverwatch.vue';
import riverwatchArticle from './templates/riverwatch-article.vue';
import riverwatchArticles from './templates/riverwatch-articles.vue';
import scrollBlocks from './partials/modules/ScrollBlocks.vue';
import searchRiverwatch from './partials/components/search-form.vue';
import searchWindow from './partials/modules/search.vue';
import socialShare from './partials/components/social-share.vue';
import tickets from './partials/modules/Tickets.vue';
// import tnaquaCursor from './partials/components/cursor.vue';
import videoBackground from './partials/components/videoBackground.vue';
import viewAllSlider from './partials/modules/ViewAllSlider.vue';
import wavyLine from './partials/components/wavy-line.vue';
import wordsUp from './partials/components/animations/WordsUp.vue';
import zoomIn from './partials/components/animations/ZoomIn.vue';

Vue.use(VueClipboard);
Vue.directive('lazyload', LazyLoadDirective);
Vue.component('cookie-consent', cookieconsent);

export default {
    init() {
        new Vue({
            el: '#launchframe-root',

            components: {
                animation,
                blob,
                classSlider,
                fadeIn,
                fadeInUp,
                headerRiverwatch,
                headerSticky,
                heroHome,
                heroImax,
                hero,
                hiddenNav,
                imageItem,
                imageSlider,
                imaxHome,
                linesUp,
                liveBlinker,
                livestream,
                location,
                magnetic,
                maps,
                mediaGrid,
                modal,
                newsletter,
                parallaxBg,
                plyr,
                reviewSlider,
                riverwatch,
                riverwatchArticle,
                riverwatchArticles,
                scrollBlocks,
                searchRiverwatch,
                searchWindow,
                socialShare,
                tickets,
                // tnaquaCursor,
                videoBackground,
                viewAllSlider,
                wavyLine,
                wordsUp,
                zoomIn
            },

            data: {
                toast: true,
                searchOpen: false,
                navOpen: false,
                newsletterModal: false
            },

            mounted() {
                this.pageIn();
            },

            methods: {
                pageIn() {
                    const tl = gsap.timeline();

                    tl.to(this.$refs.loaderLogo, {
                        opacity: 0,
                        duration: 0.4,
                        delay: 0.25,
                        onComplete: () => {
                            this.$emit('ready');
                            ScrollTrigger.refresh();
                        }
                    }).to(this.$refs.cover, {
                        opacity: 0,
                        duration: 1,
                        onComplete: this.animatedIn
                    });
                },

                animatedIn() {
                    this.$refs.loaderLogo.classList.add('hidden');
                    this.$refs.cover.classList.add('hidden');
                }
            }
        });
    },
    finalize() {}
};
